var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature Icon with circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.0173 26.0285H32.3886C32.2795 25.6397 32.2226 25.1988 32.2226 24.81C32.2226 23.1506 32.7204 21.6572 33.5501 20.3866C33.1045 19.9409 32.5498 19.5 31.9998 19.5C30.6723 19.5 28.956 21.88 28.0173 26.0285Z",
    fill: "#3869E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3623 26.0285C25.8032 23.8144 26.467 21.8801 27.3536 20.3866C24.5326 21.4344 22.2095 23.4826 20.7682 26.0285H25.3623Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.3275 28.6268H27.5718C27.4059 29.8453 27.349 31.1159 27.349 32.5003C27.349 33.8847 27.458 35.1553 27.5718 36.3737H36.4234C36.5325 35.2691 36.6463 34.1075 36.6463 32.889C35.5416 31.6706 34.3231 30.1771 33.4366 28.5746C33.4366 28.6268 33.3797 28.6268 33.3275 28.6268Z",
    fill: "#3869E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.7946 35.3211C40.5718 35.544 40.2399 35.653 39.908 35.653C39.633 35.653 39.3533 35.544 39.1352 35.378C39.1352 35.7099 39.0783 36.0418 39.0262 36.3168H44.3931C44.7819 35.0983 45 33.7708 45 32.4433C45 31.8886 44.9431 31.3386 44.8909 30.727C43.1699 33.107 41.1786 34.9893 40.7946 35.3211Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.2967 44.6135C26.467 43.1201 25.7463 41.1857 25.3054 38.9716H20.7682C22.2095 41.5129 24.5326 43.561 27.2967 44.6135Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.9823 38.9716H28.0173C28.956 43.1201 30.6723 45.5001 31.9998 45.5001C33.3273 45.5001 35.0388 43.1201 35.9823 38.9716Z",
    fill: "#3869E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.6378 38.9716C38.1969 41.1857 37.5331 43.1201 36.6465 44.6135C39.4106 43.561 41.7337 41.5176 43.2272 38.9716H38.6378Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.6069 36.3688H24.9738C24.8647 35.1503 24.7509 33.8228 24.7509 32.4953C24.7509 31.1678 24.8078 29.8403 24.9738 28.6219H19.6069C19.2228 29.8451 19 31.1726 19 32.5001C19 33.8276 19.2228 35.1551 19.6069 36.3688Z",
    fill: "#1C2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M39.9082 19.5C37.0872 19.5 34.821 21.88 34.821 24.81C34.821 26.8013 37.6419 30.286 39.9082 32.5522C42.1744 30.286 44.9954 26.8013 44.9954 24.81C44.9954 21.88 42.7291 19.5 39.9082 19.5ZM39.9082 26.6448C38.7703 26.6448 37.8458 25.7203 37.8458 24.5824C37.8458 23.4446 38.7703 22.5201 39.9082 22.5201C41.046 22.5201 41.9705 23.4446 41.9705 24.5824C41.9705 25.7203 41.046 26.6448 39.9082 26.6448Z",
    fill: "#C79939"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffices);
export default __webpack_public_path__ + "static/media/offices.38ebe00faf4599206a2df4ca7aeaf834.svg";
export { ForwardRef as ReactComponent };